const ShareLanding = () => {
  return (
    <>shareLanding</>
  )
}
export default ShareLanding
